import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import MUIDataTable from "mui-datatables";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import Tooltip from "@material-ui/core/Tooltip";
import Grid from "@material-ui/core/Grid";
import {Typography} from "@material-ui/core";
import LinearProgress from "@material-ui/core/LinearProgress";

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing(3),
        overflowX: 'auto',
    },
    table: {
        minWidth: "80vh",
    },
    actionColumn:{
        width:"10vw"
    }
}));

export default function ClipList(props) {

    const columns = [
        {
            label: 'Moment Clip ID',
            name: "id"
        },
        {
            label: 'Moment Clip Title',
            name: "title"
        },
        {
            label: 'Start Time',
            name: "startTime"
        },
        {
            label: 'End Time',
            name: "endTime"
        },
        {
            label: 'Tags',
            name: "tags"
        },
        {
            label: 'CID',
            name: "cid"
        },
        {
            label: 'Clip Title',
            name: "clip.title"
        },
        {
            label: 'Created By',
            name: "createdBy"
        },
        {
            label: 'Updated By',
            name: "updatedBy",
            options:{
                display:false
            }

        },
        {
            label: 'Action',
            name: "action",
            options: {
                filter: false,
                download: false,
                empty:true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <Grid className={classes.actionColumn} container direction="row" justify="space-between"
                              alignItems="center" spacing={0}>

                                <Button item xs={6} variant="contained" onClick={props.handleEdit.bind(this, tableMeta.rowData[0],tableMeta.rowData[5])}
                                        color="primary" className={classes.button}>
                                    Edit
                                </Button>
                            
                        </Grid>
                    );

                }
            }
        },

    ];


    let momentClips = props.momentClips;
    
    const classes = useStyles();

    const options = {
        filterType: 'textField',
        pagination: true,
        selectableRows: 'none',
        print: false,
        viewColumns: true,
        responsive: 'scrollMaxHeight'
    };

    return (
        <>
           
            {(momentClips) &&
                <MUIDataTable
                    title={"Results"}
                    data={momentClips}
                    columns={columns}
                    options={options}
                />
            }
            {(!momentClips) &&
                <LinearProgress />
            }
        </>
    )
}